import { AfterViewInit, Directive, Input, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appRadioCheckboCustomColor]'
})
export class RadioCheckboCustomColorDirective implements AfterViewInit {

  @Input() public colorCheckbox: string;

  constructor(private readonly viewRef: ViewContainerRef) {}

  private get checkboxRef(): HTMLElement {
    const checkboxWrapper = this.viewRef.element.nativeElement;
    return checkboxWrapper?.querySelector('.p-radiobutton-box') as HTMLElement as any;
  }

  ngAfterViewInit(): void {
    this.setColors();
  }

  private setColors(): void {
    const element = this.checkboxRef;
    element.style.background = this.colorCheckbox;
    element.style.borderColor = this.colorCheckbox;
  }

}
